import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogTitle } from "@/components/ui/dialog";
import { IAccount } from "@/types";
import { Input } from "./ui/input";
import { useState, useEffect } from "react";
import { Button } from "./ui/button";
import { Undo2Icon } from "lucide-react";
import { useConfigStore } from "@/stores/useConfigStore";

type RenameAccountDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  account: IAccount;
}

const RenameAccountDialog = ({ open, onOpenChange, account }: RenameAccountDialogProps) => {
  const currentNickname = useConfigStore((state) => state.config.accounts[account.id]?.nickname);
  const setAccountNickname = useConfigStore((state) => state.setAccountNickname);
  const [newName, setNewName] = useState(currentNickname || account.name);

  useEffect(() => {
    setNewName(currentNickname || account.name);
  }, [currentNickname, account.name, open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogTitle>Account Nickname</DialogTitle>
        <DialogDescription>
          Give a nickname to your account. This will not change your Google account name.
        </DialogDescription>
        <div className="flex items-center gap-4">
          <Input value={newName} onChange={(e) => setNewName(e.target.value)} />
          <Button className="rounded-full hover:bg-card hover:shadow" size={"icon"} variant={"ghost"} onClick={() => {
            setNewName(account.name);
          }}>
            <Undo2Icon className="h-4 w-4" />
          </Button>
        </div>
        <DialogFooter>
          <Button 
            className="bg-blue-600 hover:bg-blue-700 text-white"
            onClick={() => {
              const trimmedName = newName.trim();
              if (trimmedName === account.name) {
                setAccountNickname(account.id, undefined);
              } else {
                setAccountNickname(account.id, trimmedName);
              }
              onOpenChange(false);
            }}
          >
            Rename
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default RenameAccountDialog;